(function(){
  /**
   * Directive which watches its element's size and calls specified function when size changes
   *
   * <div edx-on-resize="vm.onSizeChange"></div>
   */
  angular.module('edxComponents')
  .directive('edxOnResize', [function(){
    function link(scope, element, attrs) {
      var onResize = scope.$eval(attrs.edxOnResize);
      scope.$watch(
        function () {
          return [element[0].offsetWidth, element[0].offsetHeight].join('x');
        },
        function (value) {
          var vals = value.split('x');
          onResize(Number(vals[0]), Number(vals[1]));
        }
      );
    }
    return {
      link: link
    };
  }]);
})();